import { timesheetsService } from "@/services/timesheetsService"

interface ForceClockInRequest {
  shiftId: string
  clockedInTime?: string // Optional, defaults to now
}

interface ForceClockOutRequest {
  timesheetId: string
  clockedOutTime?: string // Optional, defaults to now
}

export const timesheetService = {
  /**
   * Force clock in for a shift (admin only)
   * Uses timesheets cloud function
   */
  async forceClockIn(request: ForceClockInRequest): Promise<void> {
    await timesheetsService.forceClockIn(request)
  },

  /**
   * Force clock out for a timesheet (admin only)
   * Uses timesheets cloud function
   */
  async forceClockOut(request: ForceClockOutRequest): Promise<void> {
    await timesheetsService.forceClockOut(request)
  },
}
